import FailedIcon from "../assets/createEnvAssets/FailedIcon";
import Succeed from "../assets/createEnvAssets/Succeed";

export const MessageModalHelper=(setModal, actionSubject, status, goBack)=>{
    if(status===200) {
        setModal({
            message: "The Blueprint has been " + actionSubject + "d successfully ",
            icon: Succeed,
            submit: "Go to Blueprints",
            fnOnSubmit:goBack,
            fnOnCancel:goBack
        });
    }
    else{
        setModal({
            message: "Failed to "+ actionSubject +" Blueprint, try again later",
            icon: FailedIcon,
            submit: "Close",
            fnOnSubmit:goBack,
            fnOnCancel:goBack
        });
    }
}

